var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panel",
    [
      _c(
        "v-expansion-panel-header",
        { staticClass: "pl-3", attrs: { id: "ownersList" } },
        [
          _c(
            "div",
            [
              _c("v-icon", [_vm._v(" mdi-account-group-outline ")]),
              _c("span", { staticClass: "ml-1" }, [_vm._v("Owners")]),
            ],
            1
          ),
        ]
      ),
      _c(
        "v-expansion-panel-content",
        { staticStyle: { "padding-left": "0px" } },
        [
          _vm._l(_vm.application.owners, function (owner, index) {
            return [
              _c(
                "v-list-item",
                { key: index, attrs: { dense: "", selectable: false } },
                [
                  _c(
                    "v-list-item-icon",
                    { staticStyle: { "margin-right": "10px" } },
                    [
                      _c("graph-photo-avatar", {
                        attrs: {
                          "photo-url":
                            owner && owner.photoUrl ? owner.photoUrl : "",
                          "fallback-text": _vm.ownerInitials(owner),
                          color: _vm.ownerAvatarColor(owner),
                          size: 28,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item-content",
                    {
                      staticClass: "py-1",
                      staticStyle: { "text-align": "left" },
                    },
                    [
                      _c("div", { staticClass: "owner-row" }, [
                        _c(
                          "div",
                          { staticClass: "owner-text" },
                          [
                            _c(
                              "v-list-item-title",
                              {
                                staticClass: "owner-title",
                                attrs: { id: "ownerId_" + index },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.ownerPrimaryText(owner)) +
                                    " "
                                ),
                              ]
                            ),
                            _vm.ownerSecondaryText(owner)
                              ? _c(
                                  "v-list-item-subtitle",
                                  { staticClass: "owner-subtitle" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.ownerSecondaryText(owner)) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "owner-chip-group" },
                          [
                            _vm._l(
                              _vm.ownerChips(owner),
                              function (chip, chipIndex) {
                                return [
                                  chip.kind === "ambiguous"
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          key:
                                            "owner-chip-tip-" +
                                            index +
                                            "-" +
                                            chipIndex,
                                          attrs: {
                                            bottom: "",
                                            "max-width": "520",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "ml-2 owner-chip",
                                                            attrs: {
                                                              "x-small": "",
                                                              label: "",
                                                              outlined: "",
                                                              color: chip.color,
                                                            },
                                                          },
                                                          "v-chip",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              "x-small": "",
                                                              left: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(chip.icon)
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(chip.label) +
                                                            " "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "owner-ambiguity-tooltip",
                                            },
                                            _vm._l(
                                              _vm.ambiguityAlternateLines(
                                                owner
                                              ),
                                              function (line, lineIndex) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key:
                                                      "owner-ambiguity-line-" +
                                                      index +
                                                      "-" +
                                                      lineIndex,
                                                    staticClass:
                                                      "owner-ambiguity-line",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " + _vm._s(line) + " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "v-chip",
                                        {
                                          key:
                                            "owner-chip-" +
                                            index +
                                            "-" +
                                            chipIndex,
                                          staticClass: "ml-2 owner-chip",
                                          attrs: {
                                            "x-small": "",
                                            label: "",
                                            outlined: "",
                                            color: chip.color,
                                          },
                                        },
                                        [
                                          chip.icon
                                            ? _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    left: "",
                                                  },
                                                },
                                                [_vm._v(_vm._s(chip.icon))]
                                              )
                                            : _vm._e(),
                                          _vm._v(
                                            " " + _vm._s(chip.label) + " "
                                          ),
                                        ],
                                        1
                                      ),
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "v-list-item-icon",
                    [
                      _vm.canManageOwners
                        ? _c(
                            "v-icon",
                            {
                              attrs: { id: "deleteOwnerButton_" + index },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteOwner($event, owner)
                                },
                              },
                            },
                            [_vm._v("mdi-trash-can-outline")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { key: "owner-divider-" + index }),
            ]
          }),
          _c(
            "v-list-item",
            { staticClass: "mt-5", attrs: { dense: "" } },
            [
              _c(
                "v-list-item-icon",
                { staticStyle: { "margin-right": "10px" } },
                [_c("v-icon", [_vm._v("mdi-account-outline")])],
                1
              ),
              _c(
                "v-form",
                {
                  staticStyle: { width: "100%" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.nop.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      id: "addOwnerInput",
                      items: _vm.ownerSearchItems,
                      loading: _vm.ownerSearchLoading,
                      "error-messages": _vm.ownerSearchError,
                      disabled: !_vm.canManageOwners,
                      "item-text": "label",
                      "item-value": "ownerRef",
                      "hide-no-data": _vm.hideNoDataState,
                      "no-data-text": _vm.noDataText,
                      "no-filter": "",
                      clearable: "",
                      label: "Add Owner",
                      placeholder:
                        "Search owner by name, email, or owner reference",
                      dense: "",
                      color: "#006c27",
                    },
                    on: {
                      "update:search-input": _vm.onOwnerSearchInput,
                      change: _vm.onOwnerSelectionChanged,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function ({ item, on, attrs }) {
                          return [
                            _c(
                              "v-list-item",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "owner-option-item",
                                    attrs: { dense: "" },
                                  },
                                  "v-list-item",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c(
                                  "v-list-item-content",
                                  { staticClass: "owner-option-content" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-center owner-option-left",
                                      },
                                      [
                                        _c("graph-photo-avatar", {
                                          staticClass: "mr-2",
                                          attrs: {
                                            "photo-url":
                                              item && item.photoUrl
                                                ? item.photoUrl
                                                : "",
                                            "fallback-text":
                                              _vm.ownerInitials(item),
                                            color: _vm.ownerAvatarColor(item),
                                            size: 24,
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "owner-option-text" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "owner-title owner-option-title",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.ownerPrimaryText(item)
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _vm.ownerSecondaryText(item)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "owner-subtitle owner-option-subtitle",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.ownerSecondaryText(
                                                            item
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-list-item-action",
                                  { staticClass: "owner-option-action" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "owner-chip-group owner-chip-group--option",
                                      },
                                      [
                                        _vm._l(
                                          _vm.ownerChips(item),
                                          function (chip, chipIndex) {
                                            return [
                                              chip.kind === "ambiguous"
                                                ? _c(
                                                    "v-tooltip",
                                                    {
                                                      key:
                                                        "owner-option-chip-tip-" +
                                                        chipIndex,
                                                      attrs: {
                                                        bottom: "",
                                                        "max-width": "520",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function ({
                                                              on: chipOn,
                                                              attrs: chipAttrs,
                                                            }) {
                                                              return [
                                                                _c(
                                                                  "v-chip",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        staticClass:
                                                                          "owner-chip",
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                          label:
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          color:
                                                                            chip.color,
                                                                        },
                                                                      },
                                                                      "v-chip",
                                                                      chipAttrs,
                                                                      false
                                                                    ),
                                                                    chipOn
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                          left: "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            chip.icon
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          chip.label
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "owner-ambiguity-tooltip",
                                                        },
                                                        _vm._l(
                                                          _vm.ambiguityAlternateLines(
                                                            item
                                                          ),
                                                          function (
                                                            line,
                                                            lineIndex
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  "owner-option-ambiguity-line-" +
                                                                  lineIndex,
                                                                staticClass:
                                                                  "owner-ambiguity-line",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      line
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "v-chip",
                                                    {
                                                      key:
                                                        "owner-option-chip-" +
                                                        chipIndex,
                                                      staticClass: "owner-chip",
                                                      attrs: {
                                                        "x-small": "",
                                                        label: "",
                                                        outlined: "",
                                                        color: chip.color,
                                                      },
                                                    },
                                                    [
                                                      chip.icon
                                                        ? _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                                left: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  chip.icon
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(chip.label) +
                                                          " "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "selection",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-center owner-selection-wrap",
                              },
                              [
                                _c("graph-photo-avatar", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    "photo-url":
                                      item && item.photoUrl
                                        ? item.photoUrl
                                        : "",
                                    "fallback-text": _vm.ownerInitials(item),
                                    color: _vm.ownerAvatarColor(item),
                                    size: 20,
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "owner-selection-text" },
                                  [_vm._v(_vm._s(_vm.ownerPrimaryText(item)))]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "append-item",
                        fn: function () {
                          return [
                            _vm.hasMoreOwnerResults
                              ? _c(
                                  "v-list-item",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          text: "",
                                          small: "",
                                          color: "#006c27",
                                          loading: _vm.ownerSearchLoading,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.loadMoreOwners.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" Load more results ")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.selectedOwnerRef,
                      callback: function ($$v) {
                        _vm.selectedOwnerRef = $$v
                      },
                      expression: "selectedOwnerRef",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-list-item-icon",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        id: "addOwnerButton",
                        loading: _vm.loading,
                        disabled:
                          !_vm.canManageOwners ||
                          !_vm.selectedOwnerRef ||
                          _vm.dataLoading ||
                          !_vm.selectedOwnerIsAddable,
                      },
                      on: { click: _vm.addOwner },
                      scopedSlots: _vm._u([
                        {
                          key: "loader",
                          fn: function () {
                            return [
                              _c(
                                "span",
                                { staticClass: "custom-loader" },
                                [
                                  _c("v-icon", { attrs: { light: "" } }, [
                                    _vm._v("mdi-cached"),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [_c("v-icon", [_vm._v("mdi-account-plus-outline")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.canManageOwners
            ? _c(
                "v-list-item",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-subtitle", [
                        _vm._v(
                          " You are not an owner or admin of this application and cannot manage owners. "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: 3000, bottom: "", color: "#006c27" },
          model: {
            value: _vm.showSnackError,
            callback: function ($$v) {
              _vm.showSnackError = $$v
            },
            expression: "showSnackError",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackErrorMessage) + " ")]
      ),
      _c("confirm-delete-overlay", {
        on: { confirm: _vm.onRealDeleteOwner },
        model: {
          value: _vm.confirmDelete,
          callback: function ($$v) {
            _vm.confirmDelete = $$v
          },
          expression: "confirmDelete",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }